import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import Workspace from 'src/entities/workspace';
import { getWorkspacesArray } from 'src/selectors/workspaces';

const useHasWorkspaceWithCustomBranding = (): boolean => {
	const workspaces: Workspace[] = useSelector( getWorkspacesArray );
	return useMemo( () => workspaces.some( workspace => workspace.hasCustomBranding ), [ workspaces ] );
};

export default useHasWorkspaceWithCustomBranding;
